import React from 'react';
import { Summary as ReportSummaryShape } from '../../shapes/report';
import ReportSummaryReceiver from './report-summary-receiver';
import Classes from './styles/index';

class ReportSummary extends React.Component {

  render() {
    return (
      <React.Fragment>
        <strong>Location Summary</strong>
        <table className={Classes.reportSummaryTable}>
          <thead>
          <tr>
            <td><em>Person(s) Receiving Income</em></td>
            <td><em>SS or FED ID</em></td>
            <td><em>Amount Received Before Tax</em></td>
            <td><em>Tax</em></td>
          </tr>
          </thead>
          <tbody>
          {
            this.props.summary.receivers
              .map(
                (receiver, index) => <ReportSummaryReceiver receiver={receiver} key={index} />
              )
          }
          <tr>
            <td>
              <strong>Total Tax Due:</strong>
            </td>
            <td colSpan="2" />
            <td>
              <strong>{this.props.summary.totalTax}</strong>
            </td>
          </tr>
          </tbody>
        </table>
      </React.Fragment>
    )
  }

}

ReportSummary.propTypes = {
  summary: ReportSummaryShape.isRequired
};

export default ReportSummary;


// WEBPACK FOOTER //
// ./src/views/report/report-summary.js